import { useSelector } from 'react-redux'
import Column from '@components/column'
import {
  StyleInfoCard,
  StyleInfoRowWrapper,
  StyleTag,
  styleWrapper,
} from './style'
import Image from '@components/image'
import Row from '@components/row'
import Typography from '@components/typography'
import Status from '@commons/status'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import PatientAppointmentTabs from './tabs'
import Button from '@components/button'
import { Appointment } from '@apis'
const PatientDetails = () => {
  const { data: userAppointment } = useSelector(
    (state: any) => state.userAppointment,
  )
  const [loading, setLoading] = useState<boolean>(false)

  const [initialValues, setInitialValues] = useState<any>({
    treatments: [''],
    issues: [''],
    examinations: [''],
    investigations: [''],
    reports: [],
    medicines: [],
    labTests: [],
  })

  const submitHandler = async (values: any) => {
    setLoading(true)
    const treatments = values?.treatments?.filter(
      (treatment: any) => !!treatment,
    )
    const issues = values?.issues?.filter((issue) => !!issue)
    const investigations = values?.investigations?.filter(
      (investigation) => !!investigation,
    )
    const examinations = values?.examinations?.filter(
      (examination) => !!examination,
    )
    const labTests = values?.labTests?.map((labTest: any) => labTest?.id)
    const medicines = values?.medicines
    const payload: any = {}
    if (!!treatments?.length) {
      payload.treatments = treatments
    }
    if (!!issues?.length) {
      payload.issues = issues
    }
    if (!!investigations?.length) {
      payload.investigations = investigations
    }
    if (!!examinations?.length) {
      payload.examinations = examinations
    }
    if (!!labTests?.length) {
      payload.labTests = labTests
    }
    if (!!medicines?.length) {
      payload.medicines = medicines
    }
    if (!Object.values(payload)?.length) {
      return
    }
    await Appointment.update({
      data: payload,
      id: userAppointment?.id,
      state: 'consultAppointment',
    }).catch(() => {})
    setLoading(false)
  }

  useEffect(() => {
    if (userAppointment?.id) {
      setInitialValues({
        ...initialValues,
        medicines: userAppointment?.appointments?.[0]?.infos?.medicines || [],
      })
    }
  }, [userAppointment])
  return (
    <Column rowGap={20} styleColumn={styleWrapper}>
      <StyleInfoCard>
        <StyleInfoRowWrapper>
          <Image src={`${process.env.BUCKET_URL}/${userAppointment?.avatar}`} />
          <Column styleColumn="width:100%;">
            <Row
              justifyContent="space-between"
              alignItems="center"
              styleRow="width:100%"
            >
              <Typography
                content={userAppointment?.name}
                size={14}
                tc="text100"
              />
              <Status status={userAppointment?.appointments?.[0]?.status} />
            </Row>
            <Row colGap={10}>
              <StyleTag>{userAppointment?.infos?.gender}</StyleTag>
              <StyleTag>{userAppointment?.infos?.age}</StyleTag>
              <StyleTag>{userAppointment?.infos?.bloodGroup}</StyleTag>
            </Row>
          </Column>
        </StyleInfoRowWrapper>
      </StyleInfoCard>
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit, values, setFieldValue }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <PatientAppointmentTabs
                  values={values}
                  setFieldValue={setFieldValue}
                  userAppointment={userAppointment}
                />
                <Button
                  title="Save"
                  styleButtonWrapper="width:100%;position:sticky;bottom:-20px;"
                  styleButton="width:100%"
                  height={40}
                  loading={loading}
                />
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default PatientDetails
